// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"ModalWindow_modal_wrapper__rtmjl","modal_title":"ModalWindow_modal_title__bMF9I","modal_text":"ModalWindow_modal_text__5qCek"};